<template>
  <div>
    <label class="block text-sm font-medium text-gray-700">
      {{ label }}
    </label>
    <div class="mt-1 relative w-full pr-10 text-gray-900 sm:text-sm">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['label', 'value']
}
</script>
